import * as React from "react";
import { action, observable } from "mobx";
import { observer, inject } from "mobx-react";
import { ILocalization } from "../../../models/localization";
import { hashHistory } from "react-router";
import { LookupValue } from "../../../models/lookup";
import { ProfileSkillState, ScreenMode, LookupType, JobType, EdType } from "../../../models/enums";
import { ExperienceSkill, ProfileSkill, WorkExperience, EducationExperience, ActivityExperience, CCLCExperience } from "../../../models/profile";
import { SetSkill } from "../../../models/opportunity";
import SeekerStore from "../../../stores/seekerStore";
import { SkillSuggestion } from "../../../models/skills";
import { FormControl, FormControlLabel } from "material-ui/Form";
import Select from "material-ui/Select"
import { Row, Col } from "react-flexbox-grid";
import Autosuggest from "react-autosuggest";
import TextField from "material-ui/TextField";
import { MenuItem } from "material-ui/Menu";
import Paper from "material-ui/Paper";
import { Chart } from "react-google-charts";
import List from "material-ui/List";
import Button from "material-ui/Button";
import * as s from "./updateSkills.css";
import _ from "lodash";


@inject("store") @observer
export default class UpdateSkill extends React.Component<{ store: SeekerStore }, {}> {
  private skillRef: HTMLDivElement;
  constructor(props: any) {
    super(props);
    this.skillRef = null;
  }

  scrollToBottom = () => {
    this.skillRef.scrollIntoView({block:"start", inline:"nearest", behavior: "smooth" });
  }

  componentDidMount() {
    this.scrollToBottom();
  }

  componentDidUpdate() {
    this.scrollToBottom();
  }

  @action close = (): void => {
    this.props.store.profileStore.clearSelectedSkill();
    this.props.store.opportunityStore.clearSelectedSetSkill();
    this.props.store.opportunityStore.setViewState(0);
  }
  render(): JSX.Element {
   const local: ILocalization = this.props.store.localization.fields;
   const skill: SetSkill = this.props.store.opportunityStore.selectedSetSkill;

   return (<div><div style={{ float: "left", clear: "both" }} ref={(el) => { this.skillRef = el; }}></div>
     <div className={s.container}>
       <h5 className={s.header}>{local.opportunity.addUpdate}</h5>
       <h6 className={s.highlight}>{skill.title}</h6>
      <Row>
       <Col xs={12} sm={12} md={6}>
        <Row>
          <Col xs={12} sm={12} mdOffset={1} md={11}><div dangerouslySetInnerHTML={{ __html: skill.description }}></div><br /><br /></Col>
          <Col xs={12} sm={12} mdOffset={1} md={11}>
           <p className={s.newExperienceText}>{local.profile.noExpListedQuestion}</p>
           <p className={s.blueHover} onClick={() => hashHistory.push("/profile/add-experience")}>{local.profile.addNewExp}</p>
          </Col>
        </Row>
        </Col >
        <Col xs={12} sm={12} md={6}>
          <Row>
             <Col xs={12}>
               <h6 className={s.rightSubHeading} >{local.opportunity.usedQuestion}</h6>
            </Col>
          </Row>   
          <Row>
            <Col xs={12} className={s.displayBox}>
              <SkillsMap store={this.props.store} />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row><Col xs={12} smOffset={9} sm={3}><Button raised color="secondary" onClick={this.close}>{local.opportunity.update}</Button></Col></Row>
   </div>
   </div>)
  }
}

@inject("store") @observer
export class SkillsMap extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }

  @action componentWillUnmount() {
    this.props.store.profileStore.clearSelectedSkill();
    this.props.store.opportunityStore.clearSelectedSetSkill();
    this.props.store.opportunityStore.setViewState(0);
  }
  toTitleCase(str: string): string {
    return str.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
  }
 render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    const setskill = this.props.store.opportunityStore.selectedSetSkill;   
    const jobs: Array<WorkExperience> = this.props.store.profileStore.profile.jobs;
    const education: Array<EducationExperience> = this.props.store.profileStore.profile.educations;
    const activities: Array<ActivityExperience> = this.props.store.profileStore.profile.activities;

    const usage: JSX.Element[] = [];
    this.props.store.localization.getLookup(LookupType.UseFrequency).map((lv: LookupValue, i: number): void => {
      usage.push(<MenuItem key={i} value={lv.order}>{lv.value}</MenuItem>);
   });
   const gedUsage: JSX.Element[] = [];
   this.props.store.localization.getLookup(LookupType.GEDUse).map((lv: LookupValue, i: number): void => {
     gedUsage.push(<MenuItem key={i} value={lv.order}>{lv.value}</MenuItem>);
   });
   const edUsage: JSX.Element[] = [];
   this.props.store.localization.getLookup(LookupType.SchoolUse).map((lv: LookupValue, i: number): void => {
     edUsage.push(<MenuItem key={i} value={lv.order}>{lv.value}</MenuItem>);
   });

    let items: JSX.Element[] = [];
    items.length = 0;

    //Display all work & military experience
    jobs.map((we: WorkExperience, i: number): void => {
      let match: boolean = false;
      if (we.skills.length > 0) {
       we.skills.map((skill: ExperienceSkill): void => {
          const es: ExperienceSkill = skill;
          if (es.skillId === setskill.skillId) {
            match = true;
            //if military experience
            if (we.expType === JobType.Military) {
              items.push(<Row key={"military-" + we.idHash} className={s.experienceRow}>
                <Col className={s.experienceCol} xs={12} lgOffset={2} lg={4} xlOffset={1} xl={5}>
                  <p className={s.experienceTextTitle}>{this.toTitleCase(we.position)}</p>
                  <div className={s.military}>
                    {this.props.store.localization.getLookup(LookupType.Services).map((service: LookupValue) => {
                      if (service.order === we.service) {
                        return (<p key={"service-" + service.idHash} className={s.employer}>{service.value},&nbsp;</p>)
                      }
                    })}
                    {this.props.store.localization.getLookup(LookupType.ServiceTypes).map((type: LookupValue) => {
                      if (type.order === we.serviceType) {
                        return (<p key={"type-" + type.idHash} className={s.employer}>{type.value}</p>)
                      }
                    })}
                  </div>
                </Col>
                <Col xs={12} xl={6} className={s.selectCol}>
                  <FormControl fullWidth>
                    <Select value={es.used} onChange={(e: any) => this.props.store.profileStore.updateSkillUsage(we.idHash, setskill.skillId, e.target.value)}>  //experience Id, the skill Id and the usage index
                      {usage}
                    </Select>
                  </FormControl>
                </Col>
              </Row>
              );
            } else {
              //else regular work experience
              items.push(<Row key={"work-" + we.idHash} className={s.experienceRow}>
                <Col className={s.experienceCol} xs={12} lgOffset={2} lg={4} xlOffset={1} xl={5}>
                  <p className={s.experienceTextTitle}>{we.position}</p>
                  <p className={s.experienceText}>{we.employer}</p>
                </Col>
                <Col xs={12}  xl={5} className={s.selectCol}>
                  <FormControl fullWidth>
                    <Select value={es.used} onChange={(e: any) => this.props.store.profileStore.updateSkillUsage(we.idHash, setskill.skillId, e.target.value)}>>
                      {usage}
                    </Select>
                  </FormControl>
                </Col>
              </Row>
              );
            }
          }//end of if there is a match
        })//end of skills map
      }
      // no skills associated with job so check JobType and set usage to none
      if (we.skills.length === 0 || !match) {
        if (we.expType === JobType.Military) {
          items.push(<Row key={"no-military-" + we.idHash} className={s.experienceRow}>
            <Col className={s.experienceCol} xs={12} lgOffset={2} lg={4} xlOffset={1} xl={5}>
              <p className={s.experienceTextTitle}>{we.position}</p>
              <div className={s.military}>
                {this.props.store.localization.getLookup(LookupType.Services).map((service: LookupValue) => {
                  if (service.order === we.service) {
                    return (<p key={"service-" + service.idHash} className={s.employer}>{service.value},&nbsp;</p>)
                  }
                })}
                {this.props.store.localization.getLookup(LookupType.ServiceTypes).map((type: LookupValue) => {
                  if (type.order === we.serviceType) {
                    return (<p key={"type-" + type.idHash} className={s.employer}>{type.value}</p>)
                  }
                })}
              </div>
            </Col>
            <Col xs={12} lg={5} className={s.selectCol}>
              <FormControl fullWidth>
                <Select value={0} onChange={(e: any) => this.props.store.profileStore.updateSkillUsage(we.idHash, setskill.skillId, e.target.value)}>>
                  {usage}
                </Select>
              </FormControl>
            </Col>
          </Row>
          );
        } else {
          //else regular work experience
          items.push(<Row key={"no-work-" + we.idHash} className={s.experienceRow}>
            <Col className={s.experienceCol} xs={12} lgOffset={2} lg={4} xlOffset={1} xl={5}>
              <p className={s.experienceTextTitle}>{we.position}</p>
              <p className={s.experienceText}>{we.employer}</p>
            </Col>
            <Col xs={12} lg={5} className={s.selectCol}>
              <FormControl fullWidth>
                <Select value={0} onChange={(e: any) => this.props.store.profileStore.updateSkillUsage(we.idHash, setskill.skillId, e.target.value)}>>
                  {usage}
                </Select>
              </FormControl>
            </Col>
          </Row>
          );
        }
      }
    })

    //Display all course and GEDDegree Experience
    education.map((e: EducationExperience, i: number): void => {
      let match: boolean = false;
      if (e.skills.length > 0) {
        e.skills.map((skill: ExperienceSkill): void => {
          const es: ExperienceSkill = skill;
          if (es.skillId === setskill.skillId) {
            match = true;
            if (e.edType === EdType.Course) {
              // if type is Course
              items.push(<Row key={"course-" + e.idHash} className={s.experienceRow}>
                <Col className={s.experienceCol} xs={12} lgOffset={2} lg={4} xlOffset={1} xl={5}>
                  <p className={s.experienceTextTitle}>{e.courseTitle ? e.courseTitle : e.major ? e.major : null}</p>
                  <p className={s.experienceText}>{e.name}</p>
                </Col>
                <Col xs={12} lg={5} className={s.selectCol}>
                  <FormControl fullWidth>
                    <Select value={es.used} onChange={(event: any) => this.props.store.profileStore.updateSkillUsage(e.idHash, setskill.skillId, event.target.value)}>>
                      {gedUsage}
                    </Select>
                  </FormControl>
                </Col>
              </Row>
              );
            }
            else {
              //else its GEDDegree
              items.push(<Row key={"education-" + e.idHash} className={s.experienceRow}>
                <Col className={s.experienceCol} xs={12} lgOffset={2} lg={4} xlOffset={1} xl={5}>
                  <p className={s.experienceTextTitle}>{e.major ? e.major : e.courseTitle ? e.courseTitle : null}</p>
                  <p className={s.experienceText}>{this.toTitleCase(e.name)}</p>
                </Col>
                <Col xs={12} lg={5} className={s.selectCol}>
                  <FormControl fullWidth>
                    <Select value={es.used} onChange={(event: any) => this.props.store.profileStore.updateSkillUsage(e.idHash, setskill.skillId, event.target.value)}>>
                      {e.degTypeId === 1 && gedUsage}
                      {e.degTypeId > 1 && edUsage}
                    </Select>
                  </FormControl>
                </Col>
              </Row>
              );
            }
          }
        })
      }
      if (e.skills.length === 0 || !match) {
        if (e.edType === EdType.Course) {
          // if type is Course
          items.push(<Row key={"no-course-" + e.idHash} className={s.experienceRow}>
            <Col className={s.experienceCol} xs={12} lgOffset={2} lg={4} xlOffset={1} xl={5}>
              <p className={s.experienceTextTitle}>{e.courseTitle ? e.courseTitle : e.major ? e.major : null}</p>
              <p className={s.experienceText}>{e.name}</p>
            </Col>
            <Col xs={12} lg={5} className={s.selectCol}>
              <FormControl fullWidth>
                <Select value={0} onChange={(event: any) => this.props.store.profileStore.updateSkillUsage(e.idHash, setskill.skillId, event.target.value)}>>
                  {gedUsage}
                </Select>
              </FormControl>
            </Col>
          </Row>
          );
        }
        else {
          //else its GEDDegree
          items.push(<Row key={"no-education-" + e.idHash} className={s.experienceRow}>
            <Col className={s.experienceCol} xs={12} lgOffset={2} lg={4} xlOffset={1} xl={5}>
              <p className={s.experienceTextTitle}>{e.major ? e.major : e.courseTitle ? e.courseTitle : null}</p>
              <p className={s.experienceText}>{e.name}</p>
            </Col>
            <Col xs={12} lg={5} className={s.selectCol}>
              <FormControl fullWidth>
                <Select value={0} onChange={(event: any) => this.props.store.profileStore.updateSkillUsage(e.idHash, setskill.skillId, event.target.value)}>>
                  {e.degTypeId === 1 && gedUsage}
                  {e.degTypeId > 1 && edUsage}
                </Select>
              </FormControl>
            </Col>
          </Row>
          );
        }
      }
    })

    // Display all life experiences
    activities.map((e: ActivityExperience, i: number): void => {
      let match: boolean = false;
      if (e.skills.length > 0) {
        e.skills.map((skill: ExperienceSkill): void => {
          const es: ExperienceSkill = skill;
          if (es.skillId === setskill.skillId) {
            match = true;
            items.push(<Row key={"life-" + e.idHash} className={s.experienceRow}>
              <Col className={s.experienceCol} xs={12} lgOffset={2} lg={4} xlOffset={1} xl={5}>
                <p className={s.experienceTextTitle}>{e.role}</p>
                <p className={s.experienceText}>{e.org}</p>
              </Col>
              <Col xs={12} lg={5} className={s.selectCol}>
                <FormControl fullWidth>
                  <Select value={es.used} onChange={(event: any) => this.props.store.profileStore.updateSkillUsage(e.idHash, setskill.skillId, event.target.value)}>>
                    {usage}
                  </Select>
                </FormControl>
              </Col>
            </Row>
            );
          }
        })
      }
      if (!match || e.skills.length === 0) {
        items.push(<Row key={"no-life-" + e.idHash} className={s.experienceRow}>
          <Col className={s.experienceCol} xs={12} lgOffset={2} lg={4} xlOffset={1} xl={5}>
            <p className={s.experienceTextTitle}>{e.role}</p>
            <p className={s.experienceText}>{e.org}</p>
          </Col>
          <Col xs={12} lg={5} className={s.selectCol}>
            <FormControl fullWidth>
              <Select value={0} onChange={(event: any) => this.props.store.profileStore.updateSkillUsage(e.idHash, setskill.skillId, event.target.value)}>>
                {usage}
              </Select>
            </FormControl>
          </Col>
        </Row>
        );
      }
    })

    if (items.length === 0) {
      items.push(<div style={{ display: "inline-flex" }}>
        <p>{local.opportunity.firstAdd}</p>
        <Button color="secondary" onClick={() => hashHistory.push('profile/add-experience/')}>{local.addExp}</Button>
      </div>)
    }

    return (<div>{items}</div>)
  }
}


// WEBPACK FOOTER //
// ./src/components/opportunity/updateSkill/index.tsx